MOVE.ADS = (function (MOVE) {
  var retrieveKruxValue = function(n) {
    var k='kx'+n;
    if (MOVE.LocalStorage.isAvailable) {
      return window.localStorage[k] || "";
    } else if (navigator.cookieEnabled) {
      return $.cookie(k);
    } else {
      return '';
    }
  };

  var initNavItemClickTrackingPixel = function () {
      var headerNavbar = $('#header-navbar');
      headerNavbar.find("a[data-omtag='header-menu:rent:geo-apartments'],a[data-omtag='header-menu:rent:apartments']").click(function () {
          MOVE.Medias.kruxPixel('KUbPeVsu', {listing_type: 'apt'});
          return true;
      });
      headerNavbar.find("a[data-omtag='header-menu:rent:geo-single-family-homes']").click(function () {
          MOVE.Medias.kruxPixel('KUbPeVsu', {listing_type: 'homes'});
          return true;
      });
      headerNavbar.find("a[data-omtag='header-menu:rent:geo-condo/townhouses'],a[data-omtag='header-menu:rent:condo/townhouses']").click(function () {
          MOVE.Medias.kruxPixel('KUbPeVsu', {listing_type: 'condo'});
          return true;
      });
      headerNavbar.find("a[data-omtag='header-menu:rent:all-geo-rentals'],a[data-omtag='header-menu:rent:all-rentals']").click(function () {
          MOVE.Medias.kruxPixel('KUbPeVsu', {listing_type: 'all'});
          return true;
      });
  };

  var init = function () {
    window.Krux.user = retrieveKruxValue('user');
    window.Krux.segments = retrieveKruxValue('segs') && retrieveKruxValue('segs').split(',') || [];
    window.kxdl = {};

    window.addEventListener("load", initNavItemClickTrackingPixel);

  };

  MOVE.ADS =
  {
    init: init
  };
  return MOVE.ADS;

})(MOVE || {});
MOVE.ADS.init();



// WEBPACK FOOTER //
// ./media/placements.js